// extracted by mini-css-extract-plugin
export var editInput = "_h3-0";
export var editInputCompact = "_h3-2";
export var editInputLarge = "_h3-1";
export var editInputSmall = "_h3-3";